// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import * as AppDetails from 'app/entities/AppDetails';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import PreloadPage from 'app/common/components/PreloadPage';
import SplitLoginPage from 'app/login/components/SplitLoginPage';
import hocify from 'app/common/components/hocify';

const mapStateToProps = (
  state,
  props: { params?: { appId: number, title: string, image: string } }
) => {
  const { title, image } = props.params
    ? AppDetails.selectors.all.details(props.params.appId, state)
    : {};

  return {
    ...props,
    appTitle: title,
    appImage: image,
    isLoading: !title && !image,
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  props: {
    params?: {
      appId: number,
    },
    query?: {
      next: string,
    },
  }
) => {
  const appId = props.params ? props.params.appId : '';
  const appType =
    props.query && props.query.next.includes('builder') ? 'wb' : 'cli';

  return {
    onLoad() {
      dispatch(AppDetails.actions.loadEntity(null, `${appType}/${appId}`));
    },
  };
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(LoadingBlockOrComponent, { LoadingComponent: PreloadPage })
)(SplitLoginPage);
